<template>
  <div
    v-scroll="handleScroll"
    id="jonathan"
    class="jonathan"
  >
    <div class="image"></div>
    <div
      class="serrure"
      :style="middleWidth"
    ></div>
    <div class="temoignages">
      <div class="temoignage">
        <div class="texte">
          <BR /><BR />{{ $t("temoignages.beproject") }}
          <p
            class="sous-texte"
            v-html="$t('temoignages.beprojectUnder')"
          ></p>
        </div>
      </div>
      <div class="temoignage">
        <div class="texte">
          <BR />{{ $t("temoignages.isis") }}
          <p
            class="sous-texte"
            v-html="$t('temoignages.isisUnder')"
          ></p>
        </div>
      </div>
      <div class="temoignage">
        <div class="texte">
          {{ $t("temoignages.bopha") }}
          <p
            class="sous-texte"
            v-html="$t('temoignages.bophaUnder')"
          ></p>
        </div>
        <div class="portrait bopha"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "JonathanPresentation",
    props: [],
    data: function () {
      return {
        width: 100
      };
    },
    computed: {
      middleWidth: function () {
        return "width:" + this.width + "vw";
      }
    },
    methods: {
      handleScroll(evt, el) {
        let y = el.getBoundingClientRect().y;
        if (y > 500 || y < -500) {
          this.width = 100;
        } else if (y < 250 && y > -100) {
          this.width = 0;
        } else if (y > 250) {
          this.width = Math.round((y - 250) / 3);
        } else if (y < -200) {
          this.width = Math.abs(Math.round((y + 200) / 3));
        }
      }
    }
  };
</script>

<style scoped>
  .sous-texte {
    font-size: 0.9rem;
    font-style: italic;
    opacity: 0.9;
  }
  .texte {
    font-size: 1.1rem;
    line-height: 1.7;
  }
  .serrure {
    background: linear-gradient(
      135deg,
      var(--flatui-color1) 0%,
      var(--flatui-color3) 100%
    );
    background-repeat: no-repeat;
    background-image: url("../assets/logo.svg");
    background-position-x: center;
    background-size: 80px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    height: 500px;
    background-blend-mode: overlay;
  }
  .portrait {
    border-radius: 50%;
    width: 100px;
    height: 100px;
    min-width: 100px;
    background-size: cover;
    border: 3px solid var(--flatui-color5);
    margin-left: 2rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .bopha {
    background: url("../assets/bopha.png") no-repeat;
    background-size: cover;
  }
  .jonathan {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 200vw;
    margin-left: -50vw;
    justify-content: center;
    background: linear-gradient(
      180deg,
      var(--flatui-color3) 0%,
      var(--flatui-color1) 100%
    );
  }
  .temoignages {
    display: flex;
    flex-direction: column;
    height: 500px;
    width: 50vw;
    justify-content: space-evenly;
    align-items: center;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
  }
  .image {
    background: url("../assets/john.png") no-repeat rgba(255, 255, 255, 0.05);
    background-size: contain;
    background-position: 50%;
    height: 500px;
    width: 50vw;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
  }
  .temoignage {
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    background-color: var(--flatui-color3);
    background-image: url("../assets/quote.svg");
    background-repeat: no-repeat;
    background-blend-mode: soft-light;
    padding: 1.5rem 2rem;
    background-position-y: -30px;
    border-radius: 12px;
    margin: 0.5rem;
    cursor: pointer;
  }
  .temoignage:hover > .portrait {
    transform: rotate(15deg) scale(1.1);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }
  .temoignage:hover {
    font-size: 1.15rem;
    background: rgba(255, 255, 255, 0.08);
    transform: translateX(8px);
  }
  @media only screen and (max-width: 500px) {
    .temoignage {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .portrait {
      display: none;
    }
  }
</style>
